export default "__VITE_ASSET__B41H3W0S__"